import React, { useState, useEffect } from 'react';
import { makeStyles, Grid, Typography, Link, CircularProgress, Box, InputLabel } from '@material-ui/core';
import { useDropzone } from "react-dropzone";
import DeleteButtonIMG from '../../assets/deleteFile.png';
import { FieldAttachment } from '../../forms/FormFieldAttachmentBase';
import ConfirmModal, { ConfirmModalHandle } from './ConfirmModal';
import { Alert } from '@material-ui/lab';
import Controls from './Controls';

const useStyles = makeStyles(() => ({

    title: {
        fontSize: '0.9em',
        color: '#000',
    },

    subTitle: {
        fontSize: '0.9em',
        color: '#000',
    },

    imageDelete: {
        width: '2em',
        float: 'right'
    },

    loadingIcon: {
        width: '2em',
        float: 'right'
    },


    dropzoneContainer: {
        display: 'flex',
        flex: '1',
        flexDirection: 'column',
        alignItems: 'center',
        borderWidth: '1px',
        borderRadius: '8px',
        borderColor: '#C6C8CC',
        borderStyle: 'dashed',
        color: '#bdbdbd',
        outline: 'none',
        transition: 'border .24s ease-in-out',
    },

    dropzoneArea: {
        width: '100%',
        padding: '3% 0%',
        justifyContent: 'center',
        textAlign: 'center',
    },

    dropzoneFiles: {
        width: '100%',
        display: 'flex',
        flex: '1',
        flexDirection: 'column',
        alignItems: 'center',
    },

    dropzoneAreaItem: {
        width: '100%',
        margin: '1.5%',
        borderRadius: '8px',
        backgroundColor: '#F4F5F7',
        color: '#000',
        fontSize: '0.9em',
        fontWeight: 'bolder',
        lineHeight: '2em'
    },

}));


interface IAttachmentProps {
    label: string;
    name: string;
    mandatory?:boolean;
    infoMessage?: string;
    error: any;
    values: FieldAttachment[];
    limitedFiles: number;
    typeFiles: string;
    onChange: (e: FieldAttachment) => void;
    onDeleteFile: (e: FieldAttachment) => void;
}

export default function FileUploader(props: IAttachmentProps) {

    const { error = null, infoMessage = undefined, mandatory = null } = props;

    const classes = useStyles();
    const [files, setFiles] = useState<FieldAttachment[]>([]);
    const modalRef = React.createRef<ConfirmModalHandle>();
    const [deleteValue, setDeleteValue] = useState<FieldAttachment>();

    const onDrop = React.useCallback(acceptedFiles => {
        if (acceptedFiles) {
            acceptedFiles.forEach((file: any) => {
                const reader = new FileReader()
                reader.readAsArrayBuffer(file)
                props.onChange(new FieldAttachment(file, ""))
            })
        } else {
            setFiles(prev => [...props.values])
        }
    }, [props]);

    const { getRootProps, getInputProps } = useDropzone({
        maxFiles: props.limitedFiles,
        multiple: false,
        accept: props.typeFiles,
        noKeyboard: true,
        onDrop
    });


    useEffect(() => {
        if (props.values != null && props.values.length > 0) {
            setFiles(prev => [...props.values])
        } else {
            setFiles([])
        }
    }, [props.values]);

    const allFiles = files.map((file, i) => (
        <Grid item className={classes.dropzoneAreaItem} key={i}>
            {file.File.path}
            {((file.Id === "" || file.IsLoading) && file.ErrorMessage === "") ?
                <Box className={classes.loadingIcon}>
                    <CircularProgress style={{ 'color': 'gray', marginRight: 5, marginTop: 5 }} size={20} />
                </Box>
                :
                <img style={{ "cursor": "pointer" }} className={classes.imageDelete} alt="Ícone  para deletar uma imagem" src={DeleteButtonIMG} onClick={() => handleOpenModalChild(file, i)} />
            }

            {file.ErrorMessage ?
                <Alert severity="error">{file.ErrorMessage}</Alert>
                : null
            }

        </Grid>
    ));




    const handleOpenModalChild = (file: FieldAttachment, index: number) => {
        modalRef.current?.handleOpen(file);
        setDeleteValue(file);
    };

    const onConfirmClick = () => {
        if (deleteValue) {
            props.onDeleteFile(deleteValue);
        }
    }

    return (
        <div>
            <Grid >
                <Grid container spacing={1}>
                    <Grid item sm={12} >
                        <Box display="flex" alignItems="center">
                            <Box >
                                <InputLabel className={classes.title} {...(error && { error: true })}>{props.label}{mandatory ? " *" : ""}</InputLabel>
                            </Box>
                            {infoMessage !== undefined ?
                                <Box style={{height: "14px"}}>
                                    <Controls.TooltipHtml message={infoMessage} />
                                </Box>
                                : null
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <div className={classes.dropzoneContainer} >
                            <div className={classes.dropzoneFiles}>
                                <Grid container spacing={2}>
                                    {allFiles}
                                </Grid>
                            </div>
                            {files.length < props.limitedFiles &&

                                <div className={classes.dropzoneArea} {...getRootProps({})} >
                                    <Grid item xs={12}>
                                        <Typography className={classes.subTitle}>
                                            <Link variant="body2" > Escolha o arquivo </Link>
                                            ou arraste para anexar
                                        </Typography>
                                    </Grid>
                                    <input type="file" name={props.name}  {...getInputProps()} />
                                </div>
                            }
                        </div>
                        {error ?
                            <Box>
                                <Alert severity="error">{error}</Alert>
                            </Box>
                            : null
                        }
                    </Grid>
                </Grid>
            </Grid>
            <ConfirmModal ref={modalRef} onConfirmClick={onConfirmClick} title="Confirmar a exclusão" message="Você confirma a exclusão do arquivo ?" />
        </div>
    )
}